import type { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PageTitle } from "../../components/PageTitle";
import { emailToNameMap } from "../../constants/email-senders";
import {
  type CreateDeliveryInput,
  useCreateDeliveryApi,
  useSendDeliveryApi,
} from "../../hooks/use-delivery-api";
import { DeliveryTiming } from "../../hooks/useEmailTemplatesRestApi";
import {
  DeliveryForm,
  type DeliveryFormValues,
} from "./components/DeliveryForm";

export const DeliveryNewPage: FC = () => {
  const navigate = useNavigate();
  const { createDelivery, loading: createLoading } = useCreateDeliveryApi();
  const { sendDelivery, loading: sendLoading } = useSendDeliveryApi();

  const buildCreateInput = (
    values: DeliveryFormValues,
  ): CreateDeliveryInput => ({
    groupId: values.distributionGroupId,
    fromEmail: values.from,
    fromName: emailToNameMap[values.from] || undefined,
    subject: values.subject.trim(),
    bodyText: values.body.trim(),
    includeSender: values.includeSender,
    scheduledAt:
      values.deliveryTiming === DeliveryTiming.Scheduled
        ? new Date(values.scheduledAt).toISOString()
        : undefined,
  });

  const handleSaveDraft = async (values: DeliveryFormValues) => {
    const input = buildCreateInput(values);
    await createDelivery({ ...input, scheduledAt: undefined });
    navigate("/deliveries");
  };

  const handleSend = async (values: DeliveryFormValues) => {
    const input = buildCreateInput(values);
    const delivery = await createDelivery(input);
    if (values.deliveryTiming === DeliveryTiming.Now) {
      await sendDelivery(delivery.id);
    }
    navigate("/deliveries");
  };

  return (
    <div className="container mx-auto px-4 py-6 max-w-3xl">
      <div className="flex items-center gap-4 mb-6">
        <Link to="/deliveries" className="btn btn-ghost btn-sm">
          &larr; 戻る
        </Link>
        <PageTitle>新規メール配信</PageTitle>
      </div>

      <DeliveryForm
        saveDraftLabel="下書き保存"
        saveLoading={createLoading}
        sendLoading={sendLoading}
        onSaveDraft={handleSaveDraft}
        onSend={handleSend}
      />
    </div>
  );
};
